export const mapApiValidationErrors = (data) => {
  const mapped = {};

  const assign = (field, message) => {
    if (!field || !message || mapped[field]) return;
    mapped[field] = message;
  };

  if (Array.isArray(data?.detail)) {
    data.detail.forEach((item) => {
      const field = Array.isArray(item.loc) ? item.loc[item.loc.length - 1] : null;
      assign(field, item.msg);
    });
  }

  if (data?.errors && typeof data.errors === 'object') {
    Object.entries(data.errors).forEach(([field, value]) => {
      assign(field, Array.isArray(value) ? value[0] : value);
    });
  }

  return mapped;
};

export const getApiErrorMessage = (error, fallback = 'An unexpected error occurred') => {
  const data = error?.response?.data;

  if (!data) {
    return error?.message || fallback;
  }

  if (typeof data.message === 'string' && data.message.trim()) return data.message;
  if (typeof data.detail === 'string' && data.detail.trim()) return data.detail;

  return fallback;
};
